import { render, staticRenderFns } from "./NoCommunity.vue?vue&type=template&id=5b30055d&scoped=true&"
import script from "./NoCommunity.vue?vue&type=script&lang=js&"
export * from "./NoCommunity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b30055d",
  null
  
)

export default component.exports